import React from "react";

const RadioButton = ({ checked, onChange, name, value }) => {
    return (
        <div style={{ display: "flex", alignItems: "center", padding: "5px" }}>
            <input
                type="radio"
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                id={value}
                style={{
                    appearance: "none", // Supprimer l'apparence par défaut
                    width: "0", // Réduire la taille de l'input
                    height: "0", // Réduire la taille de l'input
                    position: "absolute", // Positionner l'input hors de la vue
                    opacity: 0, // Rendre l'input invisible
                    pointerEvents: "none", // L'input ne doit pas interférer avec les clics
                }}
            />
            {/* Afficher l'un ou l'autre SVG en fonction de "checked" */}
            {checked ? (
                // Premier SVG (avec les rectangles)
                <svg
                    width="35"
                    height="32"
                    viewBox="0 0 38 39"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        cursor: "pointer", // Permettre de cliquer sur le SVG pour changer l'état
                    }}
                    onClick={() => onChange({ target: { value } })} // Changer l'état lorsqu'on clique
                >
                    <rect x="5.35547" y="6" width="27" height="27" rx="13.5" fill="#70787B" stroke="#70787B"></rect>
                    <rect x="1" y="1.5" width="36" height="36" rx="18" stroke="#70787B" strokeWidth="2"></rect>
                </svg>
            ) : (
                // Deuxième SVG (cercle)
                <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                        cursor: "pointer", // Permettre de cliquer sur le SVG pour changer l'état
                    }}
                    onClick={() => onChange({ target: { value } })} // Changer l'état lorsqu'on clique
                >
                    <circle cx="14" cy="14" r="14" fill="#DBE3E7"/>
                </svg>
            )}
        </div>
    );
};

export default RadioButton;
